import { useAuth } from '../lib/auth';

export function LeagueSwitcher() {
  const { leagues, activeLeagueId, switchLeague } = useAuth();
  if (leagues.length <= 1) return null;
  return (
    <select
      value={activeLeagueId ?? ''}
      onChange={(e) => void switchLeague(e.target.value)}
      aria-label="Active league"
      className="rounded border border-white/20 bg-white/10 px-2 py-1 text-sm font-medium text-white outline-none transition-colors hover:bg-white/20 focus:border-white/40"
    >
      {leagues.map((l) => (
        <option key={l.id} value={l.id} className="text-ink">
          {l.name}
        </option>
      ))}
    </select>
  );
}
